import { FilterJsonProperties } from '@/entities/catalog-brands'

import { ApplyFilter } from '../types/types'

import { getFilterType } from './get-filter-type'

/**
 * Get parsed object from filter properties
 * @param newFilter
 */
export const getFilterJsonFromAppliedFilters = (newFilter: ApplyFilter[]): FilterJsonProperties =>
	newFilter.reduce((acc, item) => {
		if (!acc[item.code]) {
			acc[item.code] = {
				type: getFilterType(item.code),
				value: [item.value]
			}
		} else {
			acc[item.code].value.push(item.value)
		}

		return acc
	}, {})
